"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9470],{

/***/ 39470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ property_card; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./shared/components/property-card/withAdapter.tsx
var withAdapter = __webpack_require__(34175);
// EXTERNAL MODULE: ./shared/components/property-card/favoriteButton.tsx + 1 modules
var favoriteButton = __webpack_require__(2);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
;// CONCATENATED MODULE: ./shared/components/property-card/PropertyItemPrice.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



function PropertyItemPrice(props) {
  var t = (0,next_intl_cjs_production_min.useTranslations)("PriceRange");
  var _props$prices = props.prices,
      price = _props$prices.price,
      maximum_price = _props$prices.maximum_price,
      minimum_price = _props$prices.minimum_price,
      rent_price = _props$prices.rent_price,
      type = _props$prices.type;

  if (maximum_price && minimum_price) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledPriceContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItem, null, t("from"), " ", (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItemPrice, null, minimum_price)), (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItem, null, t("to"), " ", (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItemPrice, null, maximum_price)));
  }

  if (type == "venta") {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledPriceContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItem, null, "VENTA ", (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItemPrice, null, price)));
  }

  if (type == "alquiler") {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledPriceContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItem, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItemPrice, null, rent_price)));
  }

  if (type == "venta y alquiler") {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledPriceContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItem, null, "VENTA ", (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItemPrice, null, price)), (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItem, null, "ALQUILER ", (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItemPrice, null, rent_price)));
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledPriceContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledSinglePrice, null, price));
}

var StyledPriceContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kklpg23"
} : 0)( true ? {
  name: "vqx3x2",
  styles: "margin-bottom:5px"
} : 0);

var StyledSinglePrice = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1kklpg22"
} : 0)("font-weight:700;display:block;font-size:", 19 / 16 + "rem", ";margin-bottom:20px;text-transform:uppercase;" + ( true ? "" : 0));

var PriceRangeItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1kklpg21"
} : 0)( true ? {
  name: "ojeojy",
  styles: "font-weight:500;font-size:15px;text-transform:uppercase;color:var(--color-text-black)"
} : 0);

var PriceRangeItemPrice = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1kklpg20"
} : 0)( true ? {
  name: "kruarj",
  styles: "font-weight:700;font-size:1.1rem;@media (max-width: 500px){font-size:1.4rem;}"
} : 0);
;// CONCATENATED MODULE: ./shared/components/property-card/index.tsx


var _excluded = ["image", "isExclusive", "typePropertyLabel", "city", "street", "businessTypeLabel", "price", "measures", "parkingLots", "bathing", "bedrooms", "code", "parent_id", "sector", "is_favorite", "is_collection", "minimum_price", "maximum_price", "combineLabel", "has_trust_entity", "rent_price", "type"];

function property_card_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








function PropertyCard(props) {
  var image = props.image,
      isExclusive = props.isExclusive,
      typePropertyLabel = props.typePropertyLabel,
      city = props.city,
      street = props.street,
      businessTypeLabel = props.businessTypeLabel,
      price = props.price,
      measures = props.measures,
      parkingLots = props.parkingLots,
      bathing = props.bathing,
      bedrooms = props.bedrooms,
      code = props.code,
      parent_id = props.parent_id,
      sector = props.sector,
      is_favorite = props.is_favorite,
      is_collection = props.is_collection,
      minimum_price = props.minimum_price,
      maximum_price = props.maximum_price,
      _props$combineLabel = props.combineLabel,
      combineLabel = _props$combineLabel === void 0 ? false : _props$combineLabel,
      _props$has_trust_enti = props.has_trust_entity,
      has_trust_entity = _props$has_trust_enti === void 0 ? false : _props$has_trust_enti,
      rent_price = props.rent_price,
      type = props.type,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItem, rest, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemLink, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemThumbnail, null, (0,emotion_react_browser_esm/* jsx */.tZ)(FavButtonWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(favoriteButton/* default */.Z, {
    parent_id: parent_id,
    is_favorite: is_favorite,
    detail: props
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemImage, {
    src: image
  }), isExclusive && !combineLabel && (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyExclusiveLabel, null, "Exclusivo"), combineLabel && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, isExclusive && !is_collection && (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyExclusiveLabel, null, "Exclusivo"), !isExclusive && is_collection && (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyExclusiveLabel, null, "The RE/MAX collection"), isExclusive && is_collection && (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyExclusiveLabel, null, "Exclusivo / Collection"))), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemDetails, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemDescription, null, typePropertyLabel, " "), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemAddress, null, sector, ", ", city), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemType, null, businessTypeLabel, has_trust_entity && (0,emotion_react_browser_esm/* jsx */.tZ)(Fideo, {
    src: "/icons/fideicomiso.svg"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemPrice, {
    prices: {
      price: price,
      minimum_price: minimum_price,
      maximum_price: maximum_price,
      rent_price: rent_price,
      type: type
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemFeatures, {
    measures: measures
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemFeature, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemIcon, {
    src: "/icons/icon_car_remaxrd.svg"
  }), " ", parkingLots), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemFeature, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemIcon, {
    src: "/icons/icon_bathtub_remaxrd.svg"
  }), " ", bathing), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemFeature, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemIcon, {
    src: "/icons/icon_bed_remaxrd.svg"
  }), " ", bedrooms), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemFeature, {
    style: {
      whiteSpace: "nowrap",
      paddingLeft: 1
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemIcon, {
    src: "/icons/icon_rule_remaxrd.svg"
  }), " ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, measures, " M", (0,emotion_react_browser_esm/* jsx */.tZ)("sup", {
    className: "sup"
  }, "2")))), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertyItemCode, null, "Cod. ", code))));
} //#region Card styles


var PropertyItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehshxhm15"
} : 0)( true ? {
  name: "1ncbq65",
  styles: "position:relative;width:100%;max-width:290px;margin:0px 5px;min-height:430px;max-height:430px;background-color:#fff;box-shadow:rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;border-radius:14px;overflow:hidden;transition:box-shadow 0.4s;cursor:pointer;&:hover{box-shadow:0px 0px 15px 2px #0005;}"
} : 0);

var Fideo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ehshxhm14"
} : 0)( true ? {
  name: "1ase213",
  styles: "min-width:100px;height:auto;object-fit:cover;object-position:center"
} : 0);

var PropertyItemLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ehshxhm13"
} : 0)( true ? {
  name: "1khzo87",
  styles: "background-color:transparent;text-decoration:none"
} : 0);

var PropertyItemThumbnail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehshxhm12"
} : 0)( true ? {
  name: "7lwj5t",
  styles: "width:100%;height:170px;overflow:hidden;position:relative;text-align:center"
} : 0);

var PropertyItemDetails = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehshxhm11"
} : 0)( true ? {
  name: "s92725",
  styles: "padding:15px 20px 10px;display:flex;flex-direction:column;height:calc(100% - 170px)"
} : 0);

var PropertyItemImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ehshxhm10"
} : 0)( true ? {
  name: "9q9hg0",
  styles: "width:100%;vertical-align:middle;border-style:none"
} : 0);

var propertyItemLabelStyles =
/*#__PURE__*/

/*#__PURE__*/
(0,emotion_react_browser_esm/* css */.iv)("position:absolute;bottom:0;left:0;width:auto;min-width:45%;text-align:center;padding:5px 0;font-weight:600;font-size:", 11 / 16 + "rem", ";text-transform:uppercase;" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);

var PropertyExclusiveLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ehshxhm9"
} : 0)(propertyItemLabelStyles, " background-color:var(--color-brand-red-main);color:#fff;padding:5px 10px;" + ( true ? "" : 0));

var PropertyItemDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "ehshxhm8"
} : 0)("font-size:", 16 / 16 + "rem", ";margin-bottom:5px;text-transform:capitalize;white-space:nowrap;color:var(--color-text-black);" + ( true ? "" : 0));

var PropertyItemDescriptionLight = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ehshxhm7"
} : 0)( true ? {
  name: "1a0w822",
  styles: "font-weight:300"
} : 0);

var PropertyItemAddress = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ehshxhm6"
} : 0)("font-size:", 10 / 16 + "rem", ";display:block;margin-bottom:10px;color:#808080;text-transform:capitalize;font-weight:bold;" + ( true ? "" : 0));

var PropertyItemType = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ehshxhm5"
} : 0)("font-size:", 16 / 16 + "rem", ";display:grid;grid-template-columns:auto auto;align-items:center;flex-direction:row;justify-content:space-between;font-weight:300;color:var(--color-text-black);text-transform:uppercase;line-height:20px;margin-bottom:5px;@media screen and (max-width: 767px){font-size:14px;}" + ( true ? "" : 0));

var PropertyItemCode = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ehshxhm4"
} : 0)("display:block;text-align:center;color:var(--color-text-blue-secondary);font-weight:600;font-size:", 11 / 16 + "rem", ";margin-top:auto;position:absolute;bottom:10px;left:0;right:0;" + ( true ? "" : 0));

var PropertyItemFeatures = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ehshxhm3"
} : 0)("list-style:none;position:absolute;max-width:85%;margin:0 auto;bottom:32px;left:0;right:0;", function (props) {
  if (props.measures.toString().length >= 4) {
    return (
      /*#__PURE__*/

      /*#__PURE__*/
      (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:space-between;align-items:flex-end;", PropertyItemFeature, "{display:flex;justify-content:center;align-items:center;flex-direction:column;", PropertyItemIcon, "{margin:0;margin-bottom:5px;}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0)
    );
  }
}, ";" + ( true ? "" : 0));

var PropertyItemFeature = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "ehshxhm2"
} : 0)("display:inline-block;margin-right:7px;font-size:", 7.5 / 16 + "rem", ";color:#808080;font-weight:400;" + ( true ? "" : 0));

var PropertyItemIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ehshxhm1"
} : 0)( true ? {
  name: "1n1ftpt",
  styles: "width:50px;max-width:25px;vertical-align:middle;margin-right:5px"
} : 0);

var FavButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehshxhm0"
} : 0)( true ? {
  name: "1odordg",
  styles: "position:absolute;right:12px;top:12px"
} : 0); //#endregion End of Card styles


/* harmony default export */ var property_card = ((0,withAdapter/* default */.ZP)(PropertyCard));

/***/ })

}]);